import * as React from 'react';
import { cn } from '../../lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full border-2 border-foreground bg-card px-3 py-2 text-sm font-medium text-foreground shadow-neo-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:shadow-neo disabled:cursor-not-allowed disabled:opacity-50 transition-shadow',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
